import { useState } from 'react'

//components
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'
import { SelectButton } from 'primereact/selectbutton'
import { useForm } from 'react-hook-form'
import { Button } from 'primereact/button'

//api
import { PromptService } from '../../../../service/prompt-service'

const AddPrompt = ({ onPromptCreated }) => {
  const options = ['Default', 'Sistema']
  const [value, setValue] = useState(options[0])

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const onSubmit = (data) => {
    const promptData = {
      ...data,
      is_default: value === 'Default',
      is_system: value === 'Sistema',
    }
    PromptService.createPrompt(promptData, (response) => {
      onPromptCreated()
    })
  }

  return (
    <div className="prompt__ComponentWrapper">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <div className="prompt__InputWrapper">
            <label>Nome Prompt*</label>
            <InputText
              id="name"
              {...register('name', {
                required: 'Campo obbligatorio',
              })}
              className={errors.name ? 'p-invalid' : ''}
            />
            {errors.name && (
              <small className="p-error">{errors.name.message}</small>
            )}
          </div>
          <div className="prompt__InputWrapper">
            <label>Prompt*</label>
            <InputTextarea
              {...register('content', {
                required: 'Campo obbligatorio',
              })}
              rows={10}
              cols={30}
              className={errors.name ? 'p-invalid' : ''}
            />
          </div>
          <div className="prompt__InputWrapper">
            <label>Tipo di Prompt</label>
            <SelectButton
              value={value}
              onChange={(e) => setValue(e.value)}
              options={options}
              className="prompt__SpacedButtons"
            />
          </div>
          <Button type="Submit" style={{ marginTop: '1rem' }}>
            Salva
          </Button>
        </div>
      </form>
    </div>
  )
}

export default AddPrompt
